import React from 'react';
import PropTypes from 'prop-types';

export class ScrollDrag extends React.Component {
  p = 0;
  constructor(props) {
    super(props);
    this.state = {
      left: 0
    };

    this.slider = React.createRef();
  }

  onMouseDown = e => {
    e.persist();
    this.isDown = true;

    this.startX = e.pageX - this.slider.current.offsetLeft;
    this.scrollLeft = this.slider.current.scrollLeft;
    this.slider.current.style.cursor = "grabbing";
  };
  onMouseLeave = () => {
    this.isDown = false;
  };
  onMouseUp = () => {
    this.isDown = false;
    this.slider.current.style.cursor = "pointer";
  };
  onMouseMove = e => {
    if (!this.isDown) {
      return;
    }
    e.preventDefault();
    var x = e.pageX - this.slider.current.offsetLeft ;
    var walk = (x - this.startX) / 20;
    var z = this.slider.current.scrollLeft - walk;
    
    this.setState({ left: this.state.left + z }, () => {
      this.slider.current.scrollLeft = this.state.left;
    });
  };
  goLeftPercent = () => {
    return {
      transition: "0.01s"
    };
  };
  goLeft = () => {
    if (this.p < -970) {
      return;
    }
    this.p += 0;
    this.setState({ left: this.p, percent: true });
  };
  goRight = () => {
    if (this.p === 0) {
      return;
    }
    this.p += 0;
    this.setState({ left: this.p });
  };

  mouseMove = () => {
    if (this.state.left > 0) {
      this.setState({ left: 0 });
      return;
    } else if (this.state.left < -1) {
      this.setState({ left: -0 });
      return;
    }
  };

  render() {
    const children = this.props.children

    return (

      <div
        onMouseDown={this.onMouseDown}
        style={this.state.percent ? this.goLeftPercent() : this.mouseMove()}
        onMouseUp={this.onMouseUp}
        onMouseLeave={this.onMouseLeave}
        onMouseMove={this.onMouseMove}
        ref={this.slider}
        className="h-scroll-wrapper"
      >
        {children}
      </div>


    );
  }
}





export default ScrollDrag;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/DragScroll/DragScroll.jsx